import { render, staticRenderFns } from "./hidden-nav.vue?vue&type=template&id=a4963dd4&"
import script from "./hidden-nav.vue?vue&type=script&lang=js&"
export * from "./hidden-nav.vue?vue&type=script&lang=js&"
import style0 from "./hidden-nav.vue?vue&type=style&index=0&id=a4963dd4&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports